angular
	.module 'App.Repository'

.factory 'CustomerRepository', ['BaseRepository', (BaseRepository) ->
	class CustomerRepository extends BaseRepository
		@resource = '/customers'
		@isRestricted = true

		findByQuery: (query = null) ->
			if _.isEmpty(query)
				query = @createQuery()

			if !query.isSorted()
				query.sortBy 'name', 'ASC'

			super query

	return new CustomerRepository
]
